export enum PatientStatmentStatus {
    None = 0,
    Open = 1,
    Close = 2,
    Issue = 3,
    Cancel = 4,
    Halt = 5,
    Blocked = 6
}